import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helpersNumbers from "../../../helpers/numbers";
import Pages from "../page/Pages";
import StatePositionConstant from "./StatePositionConstant";

export default function AllPosition() {
  const params = useParams();
  const pageID = parseInt(params.pageID);
  let page = Pages.filter((page) => page.ID == pageID);
  page = page[0];
  const positions = page.positions;

  const getBadgeTypeClassStatePosition = (statePosition) => {
    let classNameBadgeType;
    switch (statePosition) {
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.PENDING
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.DISAGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.AGREE_FROM_PUBLISHER
      ]:
        classNameBadgeType = "primary";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.CONFIRM
      ]:
        classNameBadgeType = "success";
        break;

      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition.ALREADY_CONFIRMED_PENDING_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.getStatusPositionString()[
        StatePositionConstant.statusPosition
          .ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT
      ]:
        classNameBadgeType = "primary";
        break;
    }
    return classNameBadgeType;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title={`جایگاه های تبلیغاتی  `} />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="d-flex flex-column-reverse flex-sm-row justify-content-sm-between">
                <div className="pt-2 pt-sm-0">
                  <Link
                    to={`/positions/add/page/${pageID}`}
                    className="btn btn-success"
                  >
                    <span className="pl-2">
                      <i className="fa fa-plus"> </i>
                    </span>
                    <span>اضافه جایگاه کردن به این صفحه</span>
                  </Link>
                </div>
                <div className="text-left">
                  <Link
                    className="btn btn-primary"
                    to={`/page/all/publisher/${page.site_publisher_ID}`}
                  >
                    <span>بازگشت</span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left"></i>
                    </span>
                  </Link>
                </div>
              </div>
              <div className="table-responsive pt-2">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره جایگاه</td>
                      <td>تعداد بنر در جایگاه</td>
                      <td>مبلغ پایه (تومان)</td>
                      <td>مبلغ (تومان)</td>
                      <td>اندازه (ارتفاع - عرض)</td>
                      <td>وضعیت</td>
                      <td>حالت</td>
                      <td>شناسه تگ html جایگاه</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                    {positions.map((position, index) => {
                      return (
                        <tr>
                          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                          <td>{helpersNumbers.toPersianNum(position.ID)}</td>
                          <td>{helpersNumbers.toPersianNum(position.count)}</td>
                          <td className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                position.base_price
                              )
                            )}
                          </td>
                          <td className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                position.base_price / position.count
                              )
                            )}
                          </td>
                          <td style={{ letterSpacing: "2px" }}>
                            {helpersNumbers.toPersianNum(position.size)}
                          </td>
                          <td>
                            <div dir="ltr" className="text-center">
                              {position.active ? (
                                <span className="badge badge-success">
                                  فعال
                                </span>
                              ) : (
                                <span className="badge badge-danger">
                                  غیرفعال
                                </span>
                              )}
                            </div>
                          </td>
                          <td dir="ltr">
                            <span
                              className={` badge badge-${getBadgeTypeClassStatePosition(
                                position.state
                              )} `}
                            >
                              {position.state}
                            </span>
                          </td>
                          <td dir="ltr">{position.tag_html_id}</td>
                          <td>
                            {position.tag_html_id && (
                              <span className="pl-2">
                                <button
                                  className="btn btn-info"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigator.clipboard.writeText(
                                      `<div className="hil-banner-advertise" id="${position.tag_html_id}"></div>`
                                    );
                                    alert("تگ html کپی شد.");
                                  }}
                                >
                                  <i className="fas fa-copy"></i>
                                </button>
                              </span>
                            )}
                            <span className="pl-2">
                              <Link
                                to={`/positions/${position.ID}/view`}
                                className="btn btn-info"
                              >
                                <i className="fa fa-info"></i>
                              </Link>
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
